<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
        <g id="Icon-Photos" transform="translate(-1227 -440)">
            <g id="Group_61" data-name="Group 61" transform="translate(1212 124)">
            <circle id="Ellipse_5" data-name="Ellipse 5" cx="17" cy="17" r="17" transform="translate(15 316)" :fill="this.$vuetify.theme.dark ? '#A5D867' : '#ffffff'"/>
            </g>
            <path id="Path_436" data-name="Path 436" d="M1549.74,852.668a8.594,8.594,0,0,0-3.41,6.531l7.328-4.223Zm6.223,11.559-.05.029.018.012Zm2.232-12.657a8.607,8.607,0,0,0-7.206.313l7.206,4.245Zm1.314,9.115,3.95-2.3a8.607,8.607,0,0,0-3.954-6.142v4.647l.011.006Zm-13.111-.012a8.607,8.607,0,0,0,3.953,6.151l-.027-8.414Zm9.545,3.6,3.713,2.453a8.6,8.6,0,0,0,3.874-6.866Zm-4.28,3.225a8.616,8.616,0,0,0,6.684-.064l-6.7-4.427Z" transform="translate(-311 -402.627)" fill="#383935"/>
        </g>
    </svg>
</template>

<script>
export default {
  name: 'MediaIconBtn'
}
</script>

<style scoped>
    svg {
        width:34px;
        height: 34px;
    }
</style>